import { PortalEnvironment } from './environments';
import { KID_NAV } from './kid-nav';
import './kid.generated.css';

/**
 * The child space, as configuration.
 *
 * Softer than the other three: bigger radii, a blue-to-violet gradient, and a
 * rail whose items each carry their own colour rather than sharing one accent.
 *
 * Since Sprint 3 it is the kid mode of a parent's session (GAP-S01-01), with
 * the learner screens of UC-S07, S08, S11 and S12 behind it.
 */
export const KID_ENVIRONMENT: PortalEnvironment = {
  scope: 'env-kid',
  chrome: 'kid',
  navItemClass: 'nv',
  badge: 'Mi espacio',
  home: '/student',
  nav: KID_NAV,
  accountLinks: [{ label: 'Ayuda', to: '/help' }],
};
